// Mirror of routes-course/src/util/passwordPolicy.js. The server is the
// authority; this exists so the form can say what's wrong before a round trip,
// and it has to agree with the server or a password the API would accept gets
// refused here (or worse, the reverse — an encouraging form followed by a
// rejection on submit).
//
// Any non-alphanumeric counts as the special character. The previous rules
// varied by screen and each named a different set of allowed specials, so a
// password manager's output failed on some forms and not others.

export const MIN_LENGTH = 8;
export const MAX_LENGTH = 128;

export const PASSWORD_RULES_TEXT =
  'At least 8 characters, including a letter, a number and a special character.';

export const PASSWORD_ERROR =
  'Password must be at least 8 characters long and include a letter, a number and a special character.';

// Returns the unmet requirements, as fragments meant to be joined into a
// sentence. Empty means valid.
export const passwordProblems = (password) => {
  const value = typeof password === 'string' ? password : '';
  const problems = [];

  if (value.length < MIN_LENGTH) problems.push(`at least ${MIN_LENGTH} characters`);
  if (!/[A-Za-z]/.test(value)) problems.push('one letter');
  if (!/\d/.test(value)) problems.push('one number');
  if (!/[^A-Za-z0-9]/.test(value)) problems.push('one special character');

  return problems;
};

export const isValidPassword = (password) => {
  const value = typeof password === 'string' ? password : '';
  if (value.length > MAX_LENGTH) return false;
  // Leading/trailing whitespace is nearly always an invisible paste artefact
  // the user won't reproduce at sign-in, so it is refused rather than trimmed.
  if (value !== value.trim()) return false;
  return passwordProblems(value).length === 0;
};

// The message to show for a password that failed, whitespace included.
export const passwordError = (password) => {
  const value = typeof password === 'string' ? password : '';
  if (value.length > MAX_LENGTH) return `Password must be ${MAX_LENGTH} characters or fewer.`;
  if (value !== value.trim()) {
    return 'Password cannot start or end with a space.';
  }
  const problems = passwordProblems(value);
  if (problems.length === 0) return '';
  return `Password must contain ${problems.join(', ')}.`;
};
